import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import Icon from 'sharedComponents/Icon';
import { Box, Link, Typography, Badge, Drawer, List, ListItem, IconButton, Button } from '@material-ui/core';
import UserPresenter from 'presenters/UserPresenter';

import { appRoutes } from 'routes';
import useStyles from './useStyles';

const MESSAGE_ITEM_NAME = 'messages';

const MobileMenu = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [menuPanelOpen, setMenuPanelOpen] = useState();
  const { menuItems, unreadCount, currentUser, logout } = props;

  const settingsPath = appRoutes.settingsPath();
  const shouldShowSettingsLink =
    UserPresenter.isBuyer(currentUser) ||
    UserPresenter.isLoanOfficer(currentUser) ||
    UserPresenter.isRealEstateAgent(currentUser);

  const handleToggleMenuPanel = () => setMenuPanelOpen(!menuPanelOpen);

  return (
    <div className={classes.root}>
      {menuItems.map(item => {
        const { name, label, iconName, path, isActive } = item;
        const isMessageItem = name === MESSAGE_ITEM_NAME;

        return (
          <Link key={name} to={path} component={RouterLink} className={classes.menuItem}>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
              {isMessageItem ? (
                <Badge color="secondary" badgeContent={unreadCount} className={classes.icon}>
                  <Icon name={iconName} className={clsx({ [classes.activeMenuItem]: isActive })} />
                </Badge>
              ) : (
                <Icon name={iconName} className={clsx(classes.icon, { [classes.activeMenuItem]: isActive })} />
              )}
              <Typography variant="subtitle1" className={clsx({ [classes.activeMenuItem]: isActive })}>
                {t(label)}
              </Typography>
            </Box>
          </Link>
        );
      })}
      <Box
        onClick={handleToggleMenuPanel}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Icon name="account" className={classes.icon} />
        <Typography variant="subtitle1">{t('layouts.AppLayout.Menu.account')}</Typography>
      </Box>
      <Drawer anchor="right" open={menuPanelOpen} onClose={handleToggleMenuPanel}>
        <List className={classes.menuPanel} onClick={handleToggleMenuPanel}>
          <ListItem className={classes.control}>
            <Button onClick={logout}>{t('layouts.AppLayout.Menu.logout')}</Button>
            <IconButton onClick={handleToggleMenuPanel}>
              <Icon name="close" />
            </IconButton>
          </ListItem>
          {shouldShowSettingsLink && (
            <ListItem>
              <Link to={settingsPath} component={RouterLink}>
                <Typography className={classes.link} variant="h2">
                  {t('layouts.AppLayout.Menu.settings')}
                </Typography>
              </Link>
            </ListItem>
          )}
        </List>
      </Drawer>
    </div>
  );
};

MobileMenu.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  unreadCount: PropTypes.number.isRequired,
  currentUser: UserPresenter.shape().isRequired,
  logout: PropTypes.func.isRequired,
};

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/layouts/AppLayout/components/Menu/components/MobileMenu/MobileMenu.js